export const humanize = (str?: string | null) => {
  if (typeof str === 'string') {
    return str
      .replace(/[-_]/g, ' ')
      .trim()
      .split(/\s+/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }
  return '';
};

export const humanizeAuthenticatedUser = (value: string | null) => {
  if (value === 'TCR_SUPPORT') {
    return 'TCR Support';
  }
  if (value === 'TCR_SYSTEM') {
    return 'TCR System';
  }
  return value || 'N/A';
};

export const constantizeAuthenticatedUser = (label?: string) => {
  if (label === 'TCR Support') {
    return 'TCR_SUPPORT';
  }
  if (label === 'TCR System') {
    return 'TCR_SYSTEM';
  }
  return label;
};
